var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bill"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 20,
    height: 20,
    transform: "translate(4552 -80)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    transform: "translate(-4552 80)",
    clipPath: "url(#bill)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_11_",
    "data-name": "svgexport-6 (11)",
    transform: "translate(4552 -80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4723",
    "data-name": "Path 4723",
    d: "M17.586,15.916a3.107,3.107,0,0,1-.944-1.286,14.879,14.879,0,0,1-.984-5.879c0-.008,0-.015,0-.023a5.675,5.675,0,0,0-3.34-5.147V2.228A2.229,2.229,0,0,0,10.092,0H9.908A2.229,2.229,0,0,0,7.684,2.228V3.582A5.675,5.675,0,0,0,4.343,8.751a14.879,14.879,0,0,1-.984,5.879,3.107,3.107,0,0,1-.944,1.286.57.57,0,0,0-.313.648.6.6,0,0,0,.588.458H6.983a3.017,3.017,0,0,0,6.033,0h4.295a.6.6,0,0,0,.588-.458A.57.57,0,0,0,17.586,15.916ZM8.855,2.228A1.054,1.054,0,0,1,9.908,1.174h.184a1.054,1.054,0,0,1,1.052,1.054V3.2a5.675,5.675,0,0,0-2.289,0V2.228ZM10,18.826a1.849,1.849,0,0,1-1.845-1.8h3.689A1.849,1.849,0,0,1,10,18.826Zm2.359-2.978H4.024a6.142,6.142,0,0,0,.307-.539A14.835,14.835,0,0,0,5.515,8.751a4.485,4.485,0,1,1,8.97,0c0,.007,0,.014,0,.022a14.8,14.8,0,0,0,1.184,6.535,6.146,6.146,0,0,0,.307.539Z",
    fill: "#2a2a2a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.e7e411ca3c553da87d9b3d31ef28b4da.svg";
export { ForwardRef as ReactComponent };